import * as types from './actions/types';

export default (
    state = {
        cartLoading: false,
        minicartAnimation: false
    },
    action
) => {
    console.log(action.type);
    switch (action.type) {
        case types.TRIGGER_CART_LOADING:
            return { ...state, cartLoading: action.cartLoading };
        case types.TRIGGER_MINICART_ANIMATION:
            return { ...state, minicartAnimation: action.minicartAnimation };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/ProductItem/reducer.js